var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5827 37.6501C62.8544 31.0286 57.0609 24.9926 49.9126 25C42.3679 25.0111 37.1545 31.7326 37.2683 37.7427C37.4225 46.0205 43.6308 50.2668 49.5455 50.5002C57.5125 50.8152 62.5717 44.6384 62.5827 37.6464V37.6501Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5137 65.812C28.571 61.7102 31.3319 58.7867 34.2874 56.0336C35.3044 55.085 36.505 54.2995 37.7129 53.6103C40.136 52.2245 42.4527 51.1388 45.4926 52.5358C48.7345 54.0216 52.2957 53.7178 55.5963 52.2393C57.1163 51.5576 58.3462 51.6909 59.8625 52.3838C65.2228 54.8405 69.1072 58.7719 71.8827 63.9186C72.1985 64.504 72.6759 65.4064 72.6135 66.1252C71.8952 67.0309 69.2271 69.041 67.2556 70.2364C64.1386 72.152 60.6778 73.3662 57.0578 74.2629C52.8311 75.1612 48.7863 75.1942 44.6482 74.6011C42.6326 74.2602 40.5356 73.7796 38.5493 73.02C34.5887 71.6088 31.5021 69.5606 28.5755 67.294C28.2612 67.0506 27.8196 66.606 27.381 66.2565L27.5137 65.812Z",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.579 37.65C62.568 44.6383 57.5088 50.8189 49.5418 50.5039C43.6235 50.2705 37.4151 46.0241 37.2646 37.7464C37.1544 31.7363 42.3678 25.0111 49.9089 25.0037C57.0572 24.9963 62.8507 31.0286 62.579 37.6537V37.65Z",
    fill: "#A7A7A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2359f0975e4b2bd6a7c1cc1b4777ba78.svg";
export { ForwardRef as ReactComponent };